/**
 * Default no-op notification service
 * Used when no notification service is provided
 */
export const defaultNotificationService = {
    success: (message) => console.log("[Success]", message),
    error: (message) => console.error("[Error]", message),
    info: (message) => console.info("[Info]", message),
    warning: (message) => console.warn("[Warning]", message),
};
/**
 * Task-specific notification messages
 */
export const TaskNotificationMessages = {
    // Success messages
    TASK_CREATED: "Task created successfully",
    TASK_UPDATED: "Task updated successfully",
    TASK_DELETED: "Task deleted successfully",
    // Error messages
    TASK_CREATE_FAILED: "Failed to create task",
    TASK_UPDATE_FAILED: "Failed to update task",
    TASK_DELETE_FAILED: "Failed to delete task",
    TASK_LOAD_FAILED: "Failed to load tasks",
    // Auth errors
    SESSION_EXPIRED: "Your session has expired. Please log in again.",
    ACCESS_DENIED: "You don't have permission to perform this action.",
    // Validation errors
    VALIDATION_FAILED: "Please check your input and try again.",
    // Network errors
    NETWORK_ERROR: "Network error. Please check your connection.",
    // Workspace errors
    WORKSPACE_REQUIRED: "Please select a workspace first",
    WORKSPACE_ACCESS_DENIED: "You don't have access to this workspace",
};
